import { Chip } from '@mui/material';

import { Request, type PaymentStatus as PaymentStatusType } from '../../models';

interface PaymentStatusProps {
	paymentStatus: PaymentStatusType;
}

interface StatusStyle {
	color: string;
	border: string;
}

const labels: Record<string, string> = {
	[Request.paymentStatus.fullyPaid]: 'Fully Paid',
	[Request.paymentStatus.partialPaid]: 'Partially Paid',
	[Request.paymentStatus.unpaid]: 'Unpaid',
	[Request.paymentStatus.depositPaid]: 'Deposit Paid',
	[Request.paymentStatus.paymentError]: 'Payment Error',
};

const style: Record<string, StatusStyle> = {
	[Request.paymentStatus.fullyPaid]: {
		color: '#2E7D32',
		border: '1px solid #4CAF50',
	},
	[Request.paymentStatus.partialPaid]: {
		color: '#FF9800',
		border: '1px solid #FF9800',
	},
	[Request.paymentStatus.unpaid]: {
		color: '#ef4323',
		border: '1px solid #ef4323',
	},
	[Request.paymentStatus.depositPaid]: {
		color: '#FF9800',
		border: '1px solid #FF9800',
	},
	[Request.paymentStatus.paymentError]: {
		color: '#B72136',
		border: '1px solid #FF9800',
	},
};

const defaultStyle = {
	backgroundColor: '#F5F5F5',
	color: '#757575',
	border: '1px solid #BDBDBD',
};

export const PaymentStatus = ({ paymentStatus }: PaymentStatusProps) => {
	return (
		<Chip
			label={labels[paymentStatus] || 'Unknown'}
			variant="outlined"
			sx={{
				...(style[paymentStatus] || defaultStyle),
				fontWeight: 'bold',
				width: { xs: 120, sm: 130, md: 150 },
				borderRadius: '14px',
				fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
			}}
		/>
	);
};
